import { render, staticRenderFns } from "./ActivityUserForm.vue?vue&type=template&id=84c409f2&"
import script from "./ActivityUserForm.vue?vue&type=script&lang=js&"
export * from "./ActivityUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports